export default __webpack_public_path__ + "static/media/gallery_07.d14c0a23.jpg";